import React, { useEffect, useState, useRef } from "react";
import { useGlobalStore } from "@/stores/context";
import { PageStatus } from "@/stores/provider";
import { useNavigate, useLocation } from "react-router-dom";

import "./index.less";
import { Checkbox, Button, Dialog, DialogPlugin } from "tdesign-react";
import { errorToast } from "@/utils/toast";
import deepSeek from "@/assets/imgs/deepseek.png";
import Logo from "@/assets/imgs/logo.png";
import Dify from "@/assets/imgs/dif.jpeg";
import Cherry from "@/assets/imgs/cherry.svg";
import Mid from "@/assets/imgs/middd.png";
import Stable from "@/assets/imgs/sta.png";
import Icon from "@/assets/imgs/icon.png";
import Ollma from "@/assets/imgs/ollama.png";
import Logo1 from "@/assets/imgs/001.png";
import { checkInvitedCode } from "@/api/video";

function VideoAudit() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const goVideoAudit = () => {
    // window.scrollBy(600, 0); // 向下滚动100px
    // const element = document.querySelector('.bottom');
    // element?.scrollBy({ top: 100, behavior: 'smooth' });
    sectionRef.current?.scrollIntoView({
      behavior: "smooth", // 平滑滚动
      block: "start", // 垂直对齐到顶部
    });
  };

  return (
    <>
      <div className="video-audit-tips">
        <div className="video-audit-tips-left">
          <div className="video-audit-tips-left-icon">
            <img src={Logo} />
          </div>
          <div className="video-audit-tips-left-text">
            DeepSeek ChatBox Cherry Studio Dify Midjourney Stable Diffusion AI工具
          </div>
        </div>
        <div></div>
      </div>
      <div className="video-audit-content">
        <div className="video-audit-content-item">
          <div className="video-audit-content-item-left">
            <div className="video-audit-content-item-left-title">
              AI工具使用教程 AI工具免费本地部署
            </div>
            <div className="video-audit-content-item-left-title-top">
              无需依赖网络，告别卡顿，拥有专属大模型
              
            </div>
            <ul>
              <li>无需编程基础：专为小白设计，简单易用</li>
              <li>傻瓜式操作指南：3个步骤，1分钟轻松上手</li>
              <li>快速实现Ai应用：无需依赖网络，随时随地体验AI强大功能</li>
            </ul>
            <div className="video-audit-content-item-left-text">
              保姆级图文教程，快速完成部署，提供环境配置包+常见报错解决方案，如遇到问题可享远程服务。
            </div>
            <div className="video-audit-content-item-left-btn">
              <Button theme="primary" variant="outline" onClick={goVideoAudit}>
                立即查看
              </Button>
            </div>
          </div>
          <div className="video-audit-content-item-right">
            <div className="video-audit-content-item-right-img">
              <img src={Logo} alt="" /> 
            </div>
            <div className="video-audit-content-item-right-img">
              <img src={Cherry} alt="" />  &nbsp; <img src={Dify} alt="" /> 
            </div>
            <div className="video-audit-content-item-right-img">
              <img src={Icon} alt="" />   &nbsp;<div className="video-audit-content-item-right-img-mid"> <img src={Mid} alt="" /> </div>  <img src={Ollma} alt="" />
              <div className="video-audit-content-item-right-img-last"> <img src={Stable} alt="" /> </div>
            </div>
            {/* <div className="video-audit-content-item-right-img">
              <img src={Mid} alt="" /> 
            </div> */}
          </div>
        </div>
      </div>
      <div className="video-download-content" ref={sectionRef}>
        <div className="video-download-content-item">
          <div className="video-download-content-item-title01">
            快速实现大模型本地话部署：无需依赖网络，随时随地体验
          </div>
          <div className="video-download-content-item-title02">
            管家式的文字和视频说明，迅速完成AI工具部署，提供不同AI工具部署环境设定套件
          </div>
          <div className="video-download-content-item-title03">
            一键部署，永久使用
          </div>
        </div>
        <div className="video-download-content-item-download">
        <div className="video-download-content-item-download-item">
            <div className="video-download-content-item-download-item-icon">
              <div className="video-download-content-item-download-item-icon-imgBox">
                <img src={Logo} alt="" className="video-download-content-item-download-item-icon-img01" />
                <img src={Icon} alt=""  className="video-download-content-item-download-item-icon-img07"/>
                <img src={Ollma} alt=""  className="video-download-content-item-download-item-icon-img08"/>
              </div>

              <div>     </div>
            </div>
            <div className="video-download-content-item-download-item-title">
              DeepSeek AI工具
            </div>
            <div className="video-download-content-item-download-item-text">
              丰富探索汇聚前沿AI、探索学习无限制
              <br />
              管家式的图文和视频使用教程，小白用户也能更快掌握新技能
              <br />
              免费提供官方DeepSeek—R1本地部署，极速体验，对话秒级响应，持续更新
              <br />
              隐私保护，安装过程安全，对话全程加密，隐私双重保护
            </div>
            {/* <div className="video-download-content-item-download-item-price"> */}
              {/* 19.9元/永久使用 */}
            {/* </div> */}
            <div className="video-download-content-item-download-item-btn">
              <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aizl');
              }}> 
                立即查看
              </Button>
              {/* <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aizp');
              }}>
                mac下载
              </Button> */}
            </div>
          </div>
          <div className="video-download-content-item-download-item">
            <div className="video-download-content-item-download-item-icon">
              <div className="video-download-content-item-download-item-icon-imgBox">
                <img src={Logo} alt="" className="video-download-content-item-download-item-icon-img01" />
                <img src={Cherry} alt="" className="video-download-content-item-download-item-icon-img02" />
              </div>
              <div></div>
            </div>
            <div className="video-download-content-item-download-item-title">
              Cherry Studio AI工具
            </div>
            <div className="video-download-content-item-download-item-text">
              丰富探索汇聚前沿AI、探索学习无限制
              <br />
              管家式的图文和视频使用教程，小白用户也能更快掌握新技能
              <br />
              免费提供官方Cherry Studio本地部署，极速体验，对话秒级响应，持续更新
              <br />
              隐私保护，安装过程安全，对话全程加密，隐私双重保护
            </div>
            {/* <div className="video-download-content-item-download-item-price">
              19.9元/永久使用
            </div> */}
            <div className="video-download-content-item-download-item-btn">
            <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aizp');
              }}> 
                立即查看
              </Button>
            </div>
          </div>
          <div className="video-download-content-item-download-item">
            <div className="video-download-content-item-download-item-icon">
              <div className="video-download-content-item-download-item-icon-imgBox">
                <img src={Logo} alt="" className="video-download-content-item-download-item-icon-img01" />
                <img src={Dify} alt="" className="video-download-content-item-download-item-icon-img03" />
              </div>
              <div></div>
            </div>
            <div className="video-download-content-item-download-item-title">
            Dify AI工具
            </div>
            <div className="video-download-content-item-download-item-text">
              丰富探索汇聚前沿AI、探索学习无限制
              <br />
              管家式的图文和视频教程，智能体搭建、案例实践更快掌握新技能
              <br />
              免费提供官方Dify本地部署，极速体验，对话秒级响应，持续更新
              <br />
              隐私保护，安装过程安全，对话全程加密，隐私双重保护
            </div>
            {/* <div className="video-download-content-item-download-item-price">
              19.9元/永久使用
            </div> */}
            <div className="video-download-content-item-download-item-btn">
            <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aryq');
              }}> 
                立即查看
              </Button>
            </div>
          </div>
          
        </div>
        <div className="video-download-content-item-download">
          <div className="video-download-content-item-download-item">
            <div className="video-download-content-item-download-item-icon">
              <div className="video-download-content-item-download-item-icon-imgBox">
                <img src={Mid} alt="" className="video-download-content-item-download-item-icon-img04" />
              </div>
              <div></div>
            </div>
            <div className="video-download-content-item-download-item-title">
              Mdjourney AI绘画工具
            </div>
            <div className="video-download-content-item-download-item-text">
              丰富探索汇聚前沿AI、探索学习无限制
              <br />
              管家式的图文和视频教程，场景实战、快掌握新技能如何变现
              <br />
              隐私保护，安装过程安全，对话全程加密，隐私双重保护

            </div>

            <div className="video-download-content-item-download-item-btn">
            <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/arye');
              }}> 
                立即查看
              </Button>
            </div>
          </div>
          <div className="video-download-content-item-download-item">
            <div className="video-download-content-item-download-item-icon">
              <div className="video-download-content-item-download-item-icon-imgBox">
                <img src={Stable} alt="" className="video-download-content-item-download-item-icon-img05" />
              </div>
              <div></div>
            </div>
            <div className="video-download-content-item-download-item-title">
              Stable Diffusion AI工具
            </div>
            <div className="video-download-content-item-download-item-text">
            丰富探索汇聚前沿AI、探索学习无限制
              <br />
              管家式的图文和视频教程，提示词、最全大模型、微调模型更快掌握新技能
              <br />
              免费提供Stable Diffusion本地部署，极速体验，对话秒级响应，持续更新
              <br />
              隐私保护，安装过程安全，对话全程加密，隐私双重保护
            </div>
            {/* <div className="video-download-content-item-download-item-price">
              19.9元/永久使用
            </div> */}
            <div className="video-download-content-item-download-item-btn">
            <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aryo');
              }}> 
                立即查看
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="video-download-content" >
        <div className="video-download-content-item">
          <div className="video-download-content-item-title01">
            经常问的问题
          </div>
          {/* <div className="video-download-content-item-download-item-text-title">【人工客服服务时间】</div>
          <p className="video-download-content-item-download-item-text-p">工作日： 09:30 - 22：30;节假日： 09:00 - 20：00</p>  */}
          <div className="video-download-content-item-title02">
          人工客服服务时间: 工作日： 09:30 - 22：30;节假日： 09:00 - 20：00
          </div>
          {/* <div className="video-download-content-item-title03">
            一键部署，永久使用
          </div> */}
        </div>
        <div className="video-download-content-item-download1">

          <div className="video-download-content-item-download-item1">
            <div className="video-download-content-item-download-item-icon">
              {/* <div className="video-download-content-item-download-item-icon-imgBox">
              经常问的问题
              </div> */}

              <div>     </div>
            </div>
            <div className="video-download-content-item-download-item-title">
                问题答疑一
            </div>
            <div className="video-download-content-item-download-item-text">
            <div className="video-download-content-item-download-item-text-title">为什么收费？</div>
              {/* <br /> */}
              <p>DeepSeek、Cherry Studio、或者dify等软件本身免费安装，收费的部分含资料处理、提供更新更完整资料，确保用户能够优先体验到最新的技术成果。</p> 
              {/* <br /> */}
              {/* <br /> */}
              <div className="video-download-content-item-download-item-text-title">安装助手卡住了怎么办？</div>
              {/* <br /> */}
               <p> 1. 如果是安装 ollama 卡住，可以手动去下载目录中双击ollama.exe安装
               </p>
               <p>2. 如果是安装 chatbox 卡住，可以手动去下载目录中双击chatbox.exe 安装</p>
              {/* <br /> */}
            </div>
            {/* <div className="video-download-content-item-download-item-price"> */}
              {/* 19.9元/永久使用 */}
            {/* </div> */}
            <div className="video-download-content-item-download-item-btn">
              {/* <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aizp');
              }}> 
                立即查看
              </Button> */}
              {/* <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aizp');
              }}>
                mac下载
              </Button> */}
            </div>
          </div>
          <div className="video-download-content-item-download-item1">
            <div className="video-download-content-item-download-item-icon">
              {/* <div className="video-download-content-item-download-item-icon-imgBox">
              经常问的问题
              </div> */}

              <div>     </div>
            </div>
            <div className="video-download-content-item-download-item-title">
                问题答疑二
            </div>
            <div className="video-download-content-item-download-item-text">

            <div className="video-download-content-item-download-item-text-title">本地部署工具是什么？</div>
              {/* <br /> */}
             <p>您好，目前有以下几个本地部署工具</p> 
             <p>1、 ollama +  chatbox 组合而成，加载deepseek-r1 大模型，实现本地部署</p> 
             <p>2、 ollama （或API调用模型）+ cherry studio支持多服务商集成的AI对话客户端组合而成</p>
             <p>3、 ollama （或API调用模型）+ ‌Dify开源的大语言模型（LLM）应用开发平台组合而成</p> 
 
            </div>
            {/* <div className="video-download-content-item-download-item-price"> */}
              {/* 19.9元/永久使用 */}
            {/* </div> */}
            <div className="video-download-content-item-download-item-btn">
              {/* <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aizp');
              }}> 
                立即查看
              </Button> */}
              {/* <Button theme="primary" variant="outline" onClick={() => {
                window.open('https://yuanlitui.com/a/aizp');
              }}>
                mac下载
              </Button> */}
            </div>
          </div>
          <div className="video-download-content-item-download-item1">
            <div className="video-download-content-item-download-item-icon">
              {/* <div className="video-download-content-item-download-item-icon-imgBox">
              经常问的问题
              </div> */}

              <div>     </div>
            </div>
            <div className="video-download-content-item-download-item-title">
                问题答疑三
            </div>
            {/* <div className="video-download-content-item-download-item-text">
            <div className="video-download-content-item-download-item-text-title">【人工客服服务时间】</div>

             <p className="video-download-content-item-download-item-text-p">工作日： 09:30 - 22：30</p> 

               <p className="video-download-content-item-download-item-text-p">节假日： 09:00 - 20：00</p>
              <br />

              <div className="video-download-content-item-download-item-text-title">【软件安装最低系统要求】</div>

               <p> 本软件最低需要 windows 10 , windows 11 系统，如果您的系统为win7 win8 win XP, 请先升级系统后再进行安装，谢谢</p>

            </div> */}
            <div className="video-download-content-item-download-item-text">
            <div className="video-download-content-item-download-item-text-title">【软件安装最低系统要求】</div>
            <p> 本软件最低需要 windows 10 , windows 11 系统，如果您的系统为win7 win8 win XP, 请先升级系统后再进行安装，谢谢</p>

            {/* <p className="video-download-content-item-download-item-text-p">节假日： 09:00 - 20：00</p> */}
            <div className="video-download-content-item-download-item-text-title">如何知道我可以运行什么模型？</div>
            
            <div className="video-download-content-item-download-item-text-imgLogo"><img src={Logo1} alt="" /></div>
            </div>
            <div className="video-download-content-item-download-item-btn">

            </div>
          </div>
        </div>
        {/* <div className="video-download-content-item-download">
          <div className="video-download-content-item-download-item2">
            <div className="video-download-content-item-download-item-icon">


              <div>     </div>
            </div>

            <div className="video-download-content-item-download-item-text">
                <img src={Logo1} alt="" />
            </div>

          </div>


        </div> */}
      </div>
    </>
  );
}

export const Component = VideoAudit;
export default VideoAudit;
